/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * FE_PTVang (ptvang@rsupartners.com)
 *
 * @description
 *
 * @created at Tue Jan 07 2025
 **/

import { useState, useEffect, useCallback } from "react";

const useCtrlPressed = () => {
	const [isCtrlPressed, setIsCtrlPressed] = useState(false);

	const keyDownEvent = useCallback((event: KeyboardEvent) => {
		if (event.ctrlKey) {
			setIsCtrlPressed(true);
		}
	}, []);

	const keyUpEvent = useCallback((event: KeyboardEvent) => {
		if (!event.ctrlKey) {
			setIsCtrlPressed(false);
		}
	}, []);

	useEffect(() => {
		document.addEventListener("keydown", keyDownEvent);
		document.addEventListener("keyup", keyUpEvent);
		return () => {
			document.removeEventListener("keydown", keyDownEvent);
			document.removeEventListener("keyup", keyUpEvent);
		};
	}, [keyDownEvent, keyUpEvent]);

	return {
		isCtrlPressed
	};
};

export default useCtrlPressed;
